import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { CanDeactivateGuard } from './core/guards/can-deactivate.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'new-article',
        pathMatch: 'full'
      },
      {
        path: 'new-article',
        loadComponent: () => import('./features/new-article-start/new-article-start.component').then(m => m.NewArticleStartComponent)
      },
      {
        path: 'new-article-chat',
        loadComponent: () => import('./features/new-article-chat/new-article-chat.component').then(m => m.NewArticleChatComponent),
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'edit-structured-article/:id',
        loadComponent: () => import('./features/edit-structured-article/edit-structured-article.component').then(m => m.EditStructuredArticleComponent)
      },
      {
        path: 'ai-article',
        loadComponent: () => import('./features/ai-article/ai-editor/ai-editor.component').then(m => m.AiEditorComponent)
      },
      {
        path: 'ai-chat',
        loadComponent: () => import('./features/ai-article/ai-chat/ai-chat.component').then(m => m.AiChatComponent)
      },
      {
        path: 'articles',
        loadComponent: () => import('./features/article-management-new/article-management-new.component').then(m => m.ArticleManagementNewComponent)
      },
      {
        path: 'article-calendar',
        loadComponent: () => import('./features/article-calendar/article-calendar.component').then(m => m.ArticleCalendarComponent)
      },
      {
        path: 'package',
        loadComponent: () => import('./features/package/package.component').then(m => m.PackageComponent)
      },
      {
        path: 'package-checkout/:id',
        loadComponent: () => import('./features/package-checkout/package-checkout.component').then(m => m.PackageCheckoutComponent)
      },
      {
        path: 'package-history',
        loadComponent: () => import('./features/package-history/package-history.component').then(m => m.PackageHistoryComponent)
      },
      {
        path: 'connections-site',
        loadComponent: () => import('./features/connections/connections.component').then(m => m.ConnectionsComponent)
      },
      {
        path: 'connections',
        loadComponent: () => import('./features/connections/connections.component').then(m => m.ConnectionsComponent)
      },
      {
        path: 'wordpress-config',
        loadComponent: () => import('./features/wordpress-config/wordpress-config.component').then(m => m.WordPressConfigComponent)
      },
      {
        path: 'article-list',
        loadComponent: () => import('./features/article-list/article-list.component').then(m => m.ArticleListComponent)
      },
      {
        path: 'admin-management',
        loadComponent: () => import('./features/admin-management/admin-management.component').then(m => m.AdminManagementComponent)
      },
      {
        path: 'scheduled-article/:id',
        loadComponent: () => import('./features/scheduled-article-preview/scheduled-article-preview.component').then(m => m.ScheduledArticlePreviewComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/user-profile/user-profile.component').then(m => m.UserProfileComponent)
      },
      {
        path: 'create-post',
        redirectTo: 'new-article',
        pathMatch: 'full'
      },
      {
        path: 'social-editor/:articleId',
        loadComponent: () => import('./features/social-content-editor/social-content-editor.component').then(m => m.SocialContentEditorComponent)
      }
    ]
  },
  // Facebook OAuth callback (ไม่ต้อง AuthGuard เพราะ Facebook redirect กลับมาโดยตรง)
  {
    path: 'auth/facebook/callback',
    loadComponent: () => import('./features/auth/facebook-callback/facebook-callback.component').then(m => m.FacebookCallbackComponent)
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
